import { createGlobalStyle } from 'styled-components';
import Site from './Site';
import ReactToastify from './ReactTostify';
import Swal from './Swal';

const GlobalStyle = createGlobalStyle`
  ${Site}
  ${ReactToastify}
  ${Swal}
`;

export default GlobalStyle;



// WEBPACK FOOTER //
// ./src/globalstyles/GlobalStyles.js